import React, { Component, Fragment } from "react";
import DataGrid, { Column, Paging, Export } from "devextreme-react/data-grid"; //npm install devextreme@19.1 devextreme-react@19.1
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "./VehicleReplayComponent.css";
import { LoadPanel } from "devextreme-react/load-panel";
import { SelectBox } from "devextreme-react/select-box";
import DateBox from "devextreme-react/date-box";
import DataSource from "devextreme/data/data_source";
import moment from "moment";
import { BasicMapStyle, RailMapStyle } from "../../helpers/mapstylejson";
import { VehicleInfoComponent } from "../Shared/VehicleInfoComponent";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getRequestParams,
  getVehicleLabelByIndustry,
  getLocalizedString,
  parseBoolean,
  getBaseApiUrl,
  isNullOrEmpty,
  formatDate,
} from "../../helpers/globalfunctions.js";
import { IndustryType, DateFormat } from "../../helpers/fixcodes.js";
import secureLocalStorage from "react-secure-storage";
import { CreateGeofenceComponent } from "../Shared/CreateGeofenceComponent";
const VEHICLE_LABEL = getLocalizedString("Vehicle", "");
const SELECT_VEHICLE_LABEL = getLocalizedString("Select Vehicle", "");
const DATEPICKER_FORMAT = "dd/MM/yyyy HH:mm";
const DISPLAY_DATETIME_FORMAT = "DD/MM/YYYY HH:mm";
const API_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

// var MarkerWithLabel = require("markerwithlabel")(window.google.maps);

let currentTime =
  secureLocalStorage.getItem("session_locationTime") == ""
    ? new Date()
    : new Date(secureLocalStorage.getItem("session_locationTime"));
export class VehicleReplayComponent extends Component {
  static displayName = VehicleReplayComponent.name;

  constructor(props) {
    currentTime =
      secureLocalStorage.getItem("session_locationTime") == ""
        ? new Date()
        : new Date(secureLocalStorage.getItem("session_locationTime"));
    let startTime = moment(
      moment(currentTime)
        .subtract(60, "minute")
        .format(DISPLAY_DATETIME_FORMAT),
      DISPLAY_DATETIME_FORMAT
    ).toDate();
    let endTime = moment(
      moment(currentTime).endOf("day").format(DISPLAY_DATETIME_FORMAT),
      DISPLAY_DATETIME_FORMAT
    ).toDate();
    super(props);
    this.mapRef = React.createRef();

    let tripId = secureLocalStorage.getItem("session_tripId");
    let vehicleNo = secureLocalStorage.getItem("session_vehicleNo");
    let jobTrip = secureLocalStorage.getItem("session_jobTrip");

    if (jobTrip === undefined) {
      secureLocalStorage.removeItem("session_tripId");
      secureLocalStorage.removeItem("session_vehicleNo");
      secureLocalStorage.removeItem("session_vehicleReplayState");
      secureLocalStorage.removeItem("session_tripDetails");
      secureLocalStorage.removeItem("session_jobTrip");
    }
    //console.log(vehicleNo);
    let replaystate = [];
    let tripDetailstate = [];
    if (tripId !== null) {
      let sessionVehicleNo = "session_vehicleReplayState_" + tripId;
      let sessionTripDetails = "session_tripDetails_" + tripId;
      replaystate = JSON.parse(secureLocalStorage.getItem(sessionVehicleNo));
      tripDetailstate = JSON.parse(
        secureLocalStorage.getItem(sessionTripDetails)
      );
    }

    let redirectState =
      this.props.location.state !== undefined &&
        this.props.location.state !== null
        ? this.props.location.state
        : replaystate !== undefined && replaystate !== null
          ? replaystate
          : [];
    let tripDetails =
      this.props.location.tripDetails !== undefined &&
        this.props.location.tripDetails !== null
        ? this.props.location.tripDetails
        : tripDetailstate !== undefined && tripDetailstate !== null
          ? tripDetailstate
          : [];
    let serviceTypeId =
      tripDetails !== undefined && tripDetails !== null
        ? tripDetails.serviceTypeId
        : 0;

    //console.log(tripDetails.endDatetime);

    this.state = {
      loadPanelVisible: false,
      isSubmited: false,
      showPoiOnMap: false,
      locationList: [],
      locationId: 0,
      vehicleNoList: [],
      groupedVehiclesDataSource: null,
      geofence: [],
      //tripId: (redirectState === undefined || redirectState.tripId === undefined) ? 0 : redirectState.tripId,
      tripId:
        redirectState === null ||
          redirectState === undefined ||
          redirectState.tripId === undefined
          ? 0
          : redirectState.tripId,
      vehicleId:
        redirectState === null ||
          redirectState === undefined ||
          redirectState.vehicleId === undefined
          ? 0
          : redirectState.vehicleId,
      sourceUrl:
        redirectState === null ||
          redirectState === undefined ||
          redirectState.sourceUrl === undefined
          ? ""
          : redirectState.sourceUrl,
      sourceState:
        redirectState === null ||
          redirectState === undefined ||
          redirectState.sourceState === undefined
          ? ""
          : redirectState.sourceState,
      vehicleReplayModal:
        redirectState === null || redirectState === undefined
          ? false
          : redirectState.vehicleReplayModal,
      fromDatetime:
        redirectState === null ||
          redirectState === undefined ||
          redirectState.fromDatetime === undefined
          ? startTime
          : redirectState.fromDatetime,
      toDatetime:
        redirectState === null ||
          redirectState === undefined ||
          redirectState.toDatetime === undefined
          ? endTime
          : redirectState.toDatetime,
      overwriteDates:
        redirectState === null ||
          redirectState === undefined ||
          redirectState.fromDatetime === undefined
          ? true
          : false,
      tripJobNumber:
        tripDetails === undefined || tripDetails == null
          ? ""
          : tripDetails.jobNumber,
      vehicleNo:
        tripDetails === undefined || tripDetails == null
          ? ""
          : tripDetails.vehicleNo,
      tripStartDatetime:
        tripDetails === undefined ||
          tripDetails == null ||
          tripDetails.startDatetime == null
          ? ""
          : moment(tripDetails.startDatetime).format(
            DateFormat.FullDateTime24HoursLongFormat
          ),
      tripStartLocation:
        tripDetails === undefined || tripDetails == null
          ? ""
          : tripDetails.startLocation,
      tripEndDatetime:
        tripDetails === undefined ||
          tripDetails == null ||
          tripDetails.endDatetime == null
          ? ""
          : moment(tripDetails.endDatetime).format(
            DateFormat.FullDateTime24HoursLongFormat
          ),
      tripEndLocation:
        tripDetails === undefined || tripDetails == null
          ? ""
          : tripDetails.endLocation,
      tripTripStatusName:
        tripDetails === undefined || tripDetails == null
          ? ""
          : tripDetails.tripStatusName,
      tripRouteName:
        tripDetails === undefined || tripDetails == null
          ? ""
          : tripDetails.routeName,
      serviceTypeId: serviceTypeId,
      showRefreshBtn:
        tripDetails === undefined || tripDetails == null
          ? false
          : tripDetails.tripStatusName == "STARTED"
            ? true
            : false,
      previewTypeId: "0",
      center: { lat: 19.086689, lng: 72.879449 },
      zoom: 10,
      trackingObj: null,
      progress: [],
      isPlay: false,
      isStopped: true,
      isPaused: true,
      overspeedChecked: false,
      replaySpeed: 1000,
      displayPlayReplay: 0,
      speedwiseColorCodes: [],
      industryId: parseInt(
        secureLocalStorage.getItem("session_industryTypeId")
      ),
      industryName: secureLocalStorage.getItem("session_industryType"),
      mapStyle: BasicMapStyle,
      showEventLabel:
        redirectState === undefined ||
          serviceTypeId === 10 ||
          serviceTypeId === 11
          ? true
          : false,
      errors: {
        locationId: "",
        vehicleId: "",
        fromDatetime: "",
        toDatetime: "",
      },
      isTrainServiceAccount: parseBoolean(
        secureLocalStorage.getItem("session_isTrainServiceAccount")
      ),
      exportFileName: "VehicleReplay",
      showSummary: true,
      thresholdMeter: 50,
      isJobTripServiceAccount: parseBoolean(
        secureLocalStorage.getItem("session_isJobTripServiceAccount")
      ),
      allowToAddPoi: false,
    };
    this.map = null;
    this.replayMarkers = [];
    this.startEndMarkers = [];
    this.lastAnimatedMarker = null;
    this.replayTimer = null;
    this.childFrameTimer = null;
    this.replayRoutePolyLine = [];
    this.handleLocationInputChange = this.handleLocationInputChange.bind(this);
    this.handleVehicleInputChange = this.handleVehicleInputChange.bind(this);
    this.handleFromDatetimeChange = this.handleFromDatetimeChange.bind(this);
    this.handleToDatetimeChange = this.handleToDatetimeChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.playReplay = this.playReplay.bind(this);
    this.pauseReplay = this.pauseReplay.bind(this);
    this.stopReplay = this.stopReplay.bind(this);
    this.statusWebSocketInterval = null;
    this.fnCloseOtherWindows = this.fnCloseOtherWindows.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.exportButton = this.exportButton.bind(this);
    this.poiMarkers = [];
    this.frameCounter = 0;
    this.frameNumber = 0;
    this.replayCounter = 0;
    this.poiLatLong = null;
    this.poiCircle = null;
  }

  fnCloseOtherWindows = async () => {
    this.setState({ filterWindow: "none" });
  };

  toggleSidebar = (e) => {
    e.preventDefault();
  };

  //   componentWillUnmount() {
  //   clearTimeout(this.timer);
  //   cancelAnimationFrame(this.raf);
  // }

  async componentDidMount() {
    try {

      sessionStorage.setItem("session_PageName", "Replay");
      window.gtag("event", "page_view", {
        page_title: sessionStorage.getItem("session_PageName"),
        page_location: window.location.pathname,
      });
      this.vehicleNumberSelector.instance.focus();

      await this.getVehicleDropdown();
      await this.getGeofence();

      let mapStyle = null;

      let accountId = parseInt(secureLocalStorage.getItem("session_accountId"));
      if (this.state.isTrainServiceAccount) {
        mapStyle = RailMapStyle;
      }

      var menuAccess = JSON.parse(secureLocalStorage.getItem("session_menu"));
      var poiMenuAccess = menuAccess.userRoleFeature.filter(e => e.menuName === 'POI');
      if (poiMenuAccess !== null && poiMenuAccess.length > 0) {
        this.setState({
          allowToAddPoi: poiMenuAccess[0].isActive
        });
      }

      this.map = new window.google.maps.Map(this.mapRef.current, {
        center: this.state.center,
        zoom: this.state.zoom,
        styles: mapStyle,
        options: {
          gestureHandling: "greedy",
        }, // For removing Ctrl+zoom to zoom the map
        mapId: secureLocalStorage.getItem('session_googleMapKey')
      });

      window.google.maps.event.addListener(this.map, "zoom_changed", () => {
        clearTimeout(this.mapZoomChangedTimer);
        this.mapZoomChangedTimer = setTimeout(() => {
          this.mapProjectionChanged();
        }, 1000);
      });

      window.google.maps.event.addListener(this.map, "center_changed", () => {
        clearTimeout(this.mapZoomChangedTimer);
        this.mapZoomChangedTimer = setTimeout(() => {
          this.mapProjectionChanged();
        }, 1500);
      });

      let tempState = {
        displayPlayReplay: this.state.displayPlayReplay,
        previewTypeId: this.state.previewTypeId,
      };
      if (
        (this.state.serviceTypeId == 10 || this.state.serviceTypeId == 11) &&
        this.state.vehicleReplayModal
      ) {
        tempState.displayPlayReplay = 1;
        tempState.previewTypeId = "1";
      }

      this.setState(tempState, () => {
        if (
          this.state.vehicleReplayModal === undefined ||
          this.state.vehicleReplayModal === true
        ) {
          if (this.state.overwriteDates === true) {
            let fromDate = new Date(
              moment(currentTime)
                .subtract(60, "minute")
                .format("MM/DD/YYYY HH:mm")
            );
            let toDate = new Date(
              moment(currentTime).format("MM/DD/YYYY") + " 23:59"
            );
            this.setState(
              { fromDatetime: fromDate, toDatetime: toDate },
              () => {
                this.handleSearch();
              }
            );
          } else {
            this.handleSearch();
          }
        }
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".componentDidMount function",
        err
      );
    }
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    if (this.statusWebSocketInterval != null) {
      clearTimeout(this.statusWebSocketInterval);
    }

    this.setState = (state, callback) => {
      return;
    };
  }

  manageToggle = (e) => {
    if (document.getElementsByTagName("body")[0].className === "") {
      document.getElementsByTagName("body")[0].classList.add("sidebar-mini");
    }
  };

  mapProjectionChanged() {
    try {
      let bounds = this.map.getBounds();
      let _map =
        this.state.showPoiOnMap ||
          this.state.tripId != 0 ||
          this.map.getZoom() >= 14
          ? this.map
          : null;
      for (var i = 0; i < this.poiMarkers.length; i++) {
        this.poiMarkers[i].marker.setMap(
          _map != null &&
            // bounds.contains(this.poiMarkers[i].marker.getPosition())
            // ? _map
            // : null
            bounds.contains(this.poiMarkers[i].marker.position)
            ? _map
            : null
        );
        this.poiMarkers[i].shape.setMap(
          _map != null &&
            // bounds.contains(this.poiMarkers[i].marker.getPosition())
            // ? _map
            // : null
            bounds.contains(this.poiMarkers[i].marker.position)
            ? _map
            : null
        );
      }
    } catch (ex) { }
  }

  getVehicleDropdown = async () => {
    try {
      let groupedVehicleList = [];
      let vehicles = null; //JSON.parse(secureLocalStorage.getItem("session_vehicleList"));

      if (vehicles == null || vehicles.length == 0) {
        const requestParams = getRequestParams("GET");
        let userId = secureLocalStorage.getItem("session_userId");
        let accountId = secureLocalStorage.getItem("session_accountId");
        let locationId = secureLocalStorage.getItem("session_locationId");
        //const response = await fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'Vehicles/DropdownList/' + userId + "/" + accountId + "/" + locationId, requestParams);
        const response = await fetch(
          getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
          "Vehicles/ReportVehicles/" +
          userId,
          requestParams
        );
        const data = await response.json();
        vehicles = data.payload != null ? data.payload : [];
      }

      let vehicleNo = "";
      if (vehicles.length > 0) {
        let vehicle = vehicles.filter(
          (f) => f.vehicleId === this.state.vehicleId
        );
        if (vehicle.length > 0) {
          vehicleNo = vehicle[0].vehicleNo;
        }

        let list = vehicles.filter((x) => x.isActive == true);
        if (list.length > 0) {
          groupedVehicleList.push({ key: "Active", items: list });
        }
        list = vehicles.filter((x) => x.isActive == false);
        if (list.length > 0) {
          groupedVehicleList.push({ key: "InActive", items: list });
        }
      }

      this.setState({
        vehicleNoList: vehicles,
        groupedVehiclesDataSource: new DataSource({
          store: {
            type: "array",
            data: groupedVehicleList,
            key: "vehicleId",
          },
        }),
        vehicleNo: vehicleNo,
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getVehicleDropdown function",
        err
      );
    }
  };

  handleLocationInputChange(data) { }

  handleSpeedChange = async (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState({ replaySpeed: parseInt(value) }, () => {
      if (this.state.isPlay) {
        this.pauseReplay(event);
        this.playReplay(event);
      }
    });
  };

  handleVehicleInputChange(data) {
    try {
      let error = this.state.errors;
      error.vehicleId = "";
      this.setState({
        vehicleId: data.selectedItem != null ? data.selectedItem.vehicleId : 0,
        vehicleNo: data.selectedItem != null ? data.selectedItem.vehicleNo : "",
        tripId: 0,
        errors: error,
      });
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".handleVehicleInputChange function",
        error
      );
    }
  }

  handleFromDatetimeChange(date) {
    this.setState({ fromDatetime: date.value });
    this.state.errors["fromDatetime"] = "";
  }

  handleToDatetimeChange(date) {
    this.setState({ toDatetime: date.value });
    this.state.errors["toDatetime"] = "";
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (value === "1") {
    } else {
      window.clearTimeout(this.replayTimer);
    }

    this.setState(
      {
        [name]: value,
      },
      () => {
        if (this.state.vehicleReplayModal) {
          this.handleSearch();
        }
      }
    );
  }

  checkChanged = async (e) => {
    this.setState({ overspeedChecked: e.currentTarget.checked });
  };

  checkEventChanged = async (e) => {
    this.setState({ showEventLabel: e.currentTarget.checked });
  };

  handleValidation() {
    let formIsValid = true;
    try {
      let errors = this.state.errors;

      if (
        this.state.vehicleReplayModal === undefined ||
        this.state.vehicleReplayModal === false
      ) {
        errors.vehicleId = "";
        if (this.state.vehicleId === 0) {
          formIsValid = false;
          errors.vehicleId = getVehicleLabelByIndustry(
            "Please select Vehicle."
          );
        }
        this.setState({ errors: errors });
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleValidation function",
        err
      );
      formIsValid = false;
    }
    return formIsValid;
  }

  //#region SHOW POI

  getGeofence = async (callback) => {
    try {
      let accountId = secureLocalStorage.getItem("session_accountId");
      let locationId = secureLocalStorage.getItem("session_locationId");
      const requestParams = getRequestParams("GET");
      let response;
      let tripId =
        this.state.tripId !== undefined &&
          this.state.tripId !== null &&
          Number(this.state.tripId) !== 0
          ? Number(this.state.tripId)
          : 0;
      if (tripId !== 0) {
        response = await fetch(
          getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
          "Geofences/" +
          accountId +
          "/" +
          locationId +
          "/" +
          tripId,
          requestParams
        );
      } else {
        response = await fetch(
          getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
          "Geofences/" +
          accountId +
          "/" +
          locationId,
          requestParams
        );
      }
      let data = await response.json();
      if (data != null && data.payload != null && data.payload.length > 0) {
        let geofences = data.payload.filter(
          (m) =>
            m.points !== null &&
            m.points !== undefined &&
            m.points.length > 0 &&
            m.active === true
        );
        if (tripId !== 0) {
          for (var i = 0; i < geofences.length; i++) {
            let expectedTime = geofences[i].expectedTime;
            let poiInTime = geofences[i].poiInTime; //"In Time: "
            geofences[i].name =
              "#" +
              (i + 1) +
              " " +
              (expectedTime !== undefined &&
                expectedTime !== null &&
                expectedTime.length > 0
                ? moment(expectedTime).format("h:mm A") + " "
                : "") +
              geofences[i].name +
              (poiInTime !== undefined &&
                poiInTime !== null &&
                poiInTime.length > 0
                ? "<br/>In Time: " + moment(poiInTime).format("h:mm A")
                : "");
          }
        }
        this.setState({ geofence: geofences }, () => {
          this.drawPOIMarkers();
        });
      }
    } catch (ex) {
      console.log("Error in " + this.displayName + ".getGeofence function", ex);
    }
    typeof callback == "function" && callback();
  };

  drawPOIMarkers = async () => {
    let poiMarker = null;
    //let bounds = new window.google.maps.LatLngBounds();
    this.state.geofence.map(async (poi) => {
      let point = poi.points[0];
      let markerLatlong = new window.google.maps.LatLng(
        point.latitude,
        point.longitude
      );
      let polygonBounds = new window.google.maps.LatLngBounds();
      let fillColor =
        poi.polyBgColor !== undefined &&
          poi.polyBgColor !== null &&
          poi.polyBgColor !== ""
          ? poi.polyBgColor.trim()
          : "#f32e2840";
      let strokeColor =
        poi.polyBorderColor !== undefined &&
          poi.polyBorderColor !== null &&
          poi.polyBorderColor !== ""
          ? poi.polyBorderColor.trim()
          : "#f32e2880";
      if (fillColor.startsWith("#") && fillColor.length === 7)
        fillColor = fillColor + "40";
      if (strokeColor.startsWith("#") && strokeColor.length === 7)
        strokeColor = strokeColor + "80";
      let strokeOpacity =
        strokeColor.startsWith("#") && strokeColor.length === 9
          ? Number((parseInt(strokeColor.substr(7, 2), 16) / 255).toFixed(1))
          : 0.8;
      let fillOpacity =
        fillColor.startsWith("#") && fillColor.length === 9
          ? Number((parseInt(fillColor.substr(7, 2), 16) / 255).toFixed(1))
          : 0.35;
      let shape = null;
      if (poi.shapeTypeId == 1) {
        let poiCircle = new window.google.maps.Circle({
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: 1,
          fillColor: fillColor,
          fillOpacity: fillOpacity,
          center: markerLatlong,
          radius: point.radius,
          map: this.state.showPoiOnMap ? this.map : null,
          poiId: poi.id,
        });
        shape = poiCircle;
      } else {
        let Coordinates = [];
        for (var i = 0; i < poi.points.length; i++) {
          Coordinates.push({
            lat: Number(poi.points[i].latitude),
            lng: Number(poi.points[i].longitude),
          });

          polygonBounds.extend(Coordinates[i]);
        }
        let polygon = new window.google.maps.Polygon({
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: 1,
          fillColor: fillColor,
          fillOpacity: fillOpacity,
          paths: Coordinates,
          geodesic: true,
          editable: false,
          poiId: poi.id,
          editable: false,
          map: this.state.showPoiOnMap ? this.map : null,
        });
        shape = polygon;
      }
      let latLng =
        poi.shapeTypeId == 1 ? markerLatlong : polygonBounds.getCenter();
      poiMarker = null;

      if (this.state.tripId !== 0) {
        let markerbackgroundColor = "#eaf5fd";
        let markercolor = poi.name.indexOf("In Time: ") !== -1 ? "#0ac134" : "#095590";
        let markercss = poi.name.indexOf("In Time: ") !== -1 ? "replayLabelCssIn" : "replayLabelCss";

        // poiMarker = new MarkerWithLabel({
        //   position: latLng,
        //   map: this.state.showPoiOnMap ? this.map : null,
        //   icon: {
        //     url: this.state.isTrainServiceAccount
        //       ? "../assets/img/poi/LocalTrainPoi.png"
        //       : "../assets/img/poi/red.png",
        //   },
        //   labelContent: poi.name,
        //   labelStyle: {
        //     backgroundColor: markerbackgroundColor,
        //     border: "1px solid #cecece",
        //     borderRadius: "8px",
        //     padding: "2px 10px 2px 10px",
        //     fontSize: "11px",
        //     fontWeight: "bold",
        //     fontFamily: "Segoe UI",
        //     color: markercolor,
        //   },
        //   labelAnchor: new window.google.maps.Point(20, 58),
        //   text: poi.name,
        //   title: poi.name,
        // });

        const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
        let vehicleMarkerHtml = document.createElement("div");
        vehicleMarkerHtml.innerHTML = `<div class=${markercss}>${poi.name}<img src=${this.state.isTrainServiceAccount ? "../assets/img/poi/LocalTrainPoi.png" : "../assets/img/poi/red.png"} /></div>`;
        // vehicleMarkerHtml.innerHTML += `<div class='poiLabelCss'>${poi.name}</div>`;

        poiMarker = new AdvancedMarkerElement({
          position: latLng,
          map: this.state.showPoiOnMap ? this.map : null,
          title: poi.name,
          content: vehicleMarkerHtml,
        });

      } else {

        // poiMarker = new window.google.maps.Marker({
        //   poiId: poi.id,
        //   poiName: poi.name,
        //   position: latLng,
        //   map: this.state.showPoiOnMap ? this.map : null,
        //   draggable: false,
        //   title: poi.name,
        // });

        const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
        poiMarker = new AdvancedMarkerElement({
          position: latLng,
          map: this.state.showPoiOnMap ? this.map : null,
          title: poi.name,
          //content: vehicleMarkerHtml,
        });
        poiMarker.poiId = poi.id;
        poiMarker.poiName = poi.name;
      }

      this.poiMarkers.push({ marker: poiMarker, shape: shape });
    });
  };

  handleTogglePoisEvent = async (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({ showPoiOnMap: value }, () => {
      this.handleTogglePois();
    });
  };

  handleShowHideSummaryEvent = async (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({ showSummary: value });
  };

  handleTogglePois = () => {
    let _map = this.state.showPoiOnMap ? this.map : null;
    if (this.poiMarkers != null && this.poiMarkers.length > 0) {
      this.poiMarkers.map((poi) => {
        poi.marker.setMap(_map);
        poi.shape.setMap(_map);
      });
    }
  };

  //#endregion SHOW POI
  handleSearch = async (e) => {
    let vehicle = this.state.vehicleNoList.filter(
      (h) => h.vehicleId == this.state.vehicleId
    )[0];
    let vehicleNo = vehicle !== undefined ? vehicle.vehicleNo : "";
    let exportFileName =
      "VehicleReplay_" +
      moment(this.state.fromDatetime).format("DD-MM") +
      "_" +
      moment(this.state.toDatetime).endOf("day").format("DD-MM") +
      "_" +
      vehicleNo.replace(" ", "");
    this.setState(
      { exportFileName: exportFileName, showPoiOnMap: false, geofence: [] },
      () => {
        this.handleTogglePois();
      }
    );
    if (e !== undefined) {
      e.preventDefault();
    }
    var diff = moment(this.state.toDatetime).diff(
      moment(this.state.fromDatetime),
      "hour"
    );
    var hourDiff = this.state.serviceTypeId != 7 ? 48 : 240;

    if (diff > hourDiff) {
      window.clearTimeout(this.replayTimer);
      this.setState({
        isSubmited: false,
        trackingObj: null,
      });
      this.statusWebSocketInterval = setTimeout(() => {
        this.loadReplayMarkers();
      }, 3000);
      var msg =
        hourDiff == 48
          ? "Please select date range within 48 hours."
          : "Please select date range within 10 days.";
      toast.error(msg, {
        //position: toast. POSITION.TOP _CENTER,
        position: 'top-center',
        autoClose: 2000,
        style: { width: "320px" },
        hideProgressBar: false,
        newestOnTop: false,
        closeButton: true,
      });
      return;
    } else {
      if (this.handleValidation()) {
        try {
          this.setState({
            progress: [],
            isPlay: false,
            isStopped: true,
            isPaused: true,
          });

          window.clearTimeout(this.replayTimer);

          if (this.state.previewTypeId == "1") {
            this.setState({ displayPlayReplay: 1 });
          } else {
            this.setState({ displayPlayReplay: 0 });
          }
          var request = {};

          request.VehicleId = this.state.vehicleId;
          request.StartTime = moment(this.state.fromDatetime).format(
            API_DATETIME_FORMAT
          );
          request.EndTime = moment(this.state.toDatetime).format(
            API_DATETIME_FORMAT
          );
          const requestParams = getRequestParams("POST", request);

          this.setState({ isSubmited: true, loadPanelVisible: true });

          const response = await fetch(
            getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + "VehicleReplay",
            requestParams
          );

          const data = await response.json();

          if (this.state.showPoiOnMap || this.state.tripId != 0) {
            await this.getGeofence();
          }

          this.setState({ isSubmited: false, loadPanelVisible: false });
          if (
            data.payload == null ||
            data.payload.replayData == null ||
            data.payload.replayData.length === 0
          ) {
            toast.error("Replay data not found.", {
              //position: toast. POSITION.TOP _CENTER,
              position: 'top-center',
              autoClose: 2000,
              style: { width: "310px" },
              hideProgressBar: false,
              newestOnTop: false,
              closeButton: true,
            });
            this.setState({ trackingObj: null });
            this.replayCounter = 0;
            this.frameCounter = 0;
            this.frameNumber = 0;
            clearInterval(this.childFrameTimer);
            clearTimeout(this.replayTimer);

            this.clearReplayMarker();
            this.clearStartEndMarkers();
            this.clearReplayPolyline();
          } else {
            this.setState(
              {
                trackingObj: data.payload,
                speedwiseColorCodes: data.payload.speedwiseColorCodes,
              },
              () => {
                // Clear existing polylines before rendering new ones
                this.clearReplayPolyline();
                // Proceed with loading markers and drawing new polylines
                this.loadReplayMarkers();
              }
            );
          }
        } catch (err) {
          console.log(
            "Error in " + this.displayName + ".handleSearch function",
            err
          );
          window.clearTimeout(this.replayTimer);
          this.setState({
            isSubmited: false,
            trackingObj: null,
            loadPanelVisible: false,
          });
        }
      }
    }
  };
  clearReplayMarker = () => {
    if (this.replayMarkers != null && this.replayMarkers.length > 0) {
      // this.replayMarkers.map((marker) => {
      //   //marker.setMap(null);
      //   marker.map = null;
      // });
      // this.replayMarkers = [];

      for (var i = 0; i < this.replayMarkers.length; i++) {
        if (this.replayMarkers[i].map) {
          this.replayMarkers[i].map = null;
        }
      }
      this.replayMarkers = [];
    }

    if (this.lastAnimatedMarker != null) {
      // this.lastAnimatedMarker.setMap(null);
      this.lastAnimatedMarker.map = null;
      this.lastAnimatedMarker = null;
    }
  };

  clearStartEndMarkers = function () {
    if (this.startEndMarkers != null) {
      // this.startEndMarkers.map((marker) => {
      //   //marker.setMap(null);
      //   marker.map = null;
      // });

      for (var i = 0; i < this.startEndMarkers.length; i++) {
        if (this.startEndMarkers[i].map) {
          this.startEndMarkers[i].map = null;
        }
      }

      this.startEndMarkers = [];
    }
  };

  clearReplayPolyline = () => {
    console.log("Clearing polylines:", this.replayRoutePolyLine.length);
    if (this.replayRoutePolyLine && this.replayRoutePolyLine.length > 0) {
      this.replayRoutePolyLine.forEach((polyline) => {
        if (polyline) {
          polyline.setMap(null);
        }
      });
      this.replayRoutePolyLine = [];
    }
  };

  loadReplayMarkers = () => {
    this.clearReplayMarker();
    this.clearStartEndMarkers();
    this.clearReplayPolyline();

    if (this.state.trackingObj != null) {
      const bounds = new window.google.maps.LatLngBounds();
      let replayData = this.state.trackingObj.replayData;
      if (replayData != null) {
        bounds.extend(
          new window.google.maps.LatLng(
            replayData[0].latitude,
            replayData[0].longitude
          )
        );
        for (var i = 1; i <= replayData.length - 2; i++) {
          bounds.extend(
            new window.google.maps.LatLng(
              replayData[i].latitude,
              replayData[i].longitude
            )
          );
        }
        bounds.extend(
          new window.google.maps.LatLng(
            replayData[replayData.length - 1].latitude,
            replayData[replayData.length - 1].longitude
          )
        );

        this.map.fitBounds(bounds);
        this.createReplayMarker();
      }
    }
  };

  createReplayMarker = () => {
    if (this.state.trackingObj !== null) {
      this.state.trackingObj.replayData.map((replay, i) => {
        let replayNext;
        if (i <= this.state.trackingObj.replayData.length - 1) {
          replayNext = this.state.trackingObj.replayData[i + 1];
        }
        let movingstatus = "";
        if (i == 0) {
          movingstatus = "start";
          this.drawReplayMarker(replay, movingstatus);
        } else if (i == this.state.trackingObj.replayData.length - 1) {
          movingstatus = "end";
          this.drawReplayMarker(replay, movingstatus);
        } else {
          movingstatus = "position";
          if (this.state.previewTypeId == "1") {
            if (
              replay.status === "Stopped" ||
              replay.status === "Idle" ||
              !isNullOrEmpty(replay.jobTripEvent)
            ) {
              this.drawReplayMarker(replay, movingstatus);
            }
          } else {
            this.drawReplayMarker(replay, movingstatus);
          }
        }

        if (this.state.previewTypeId == "1" && replayNext != undefined) {
          this.drawRoutePolyline(
            replay.latitude,
            replay.longitude,
            replayNext.latitude,
            replayNext.longitude,
            "",
            replayNext.speed
          );
        }
      });
      //align overlapping markers.
      try {
        for (var i = 0; i < this.replayMarkers.length; i++) {
          var markerA = this.replayMarkers[i];
          for (var j = i + 1; j < this.replayMarkers.length; j++) {
            var markerB = this.replayMarkers[j];
            if (markerA != null && markerB != null) {
              var dist =
                window.google.maps.geometry.spherical.computeDistanceBetween(
                  // markerA.getPosition(),
                  // markerB.getPosition()
                  markerA.position,
                  markerB.position,
                );
              if (dist < 5.0) {
                //var oldLatLng = markerB.getPosition();
                var oldLatLng = markerB.position;
                var newLatLng = new window.google.maps.LatLng(
                  oldLatLng.lat + 0.00004,
                  oldLatLng.lng
                );
                //markerB.setPosition(newLatLng);
                markerB.position = newLatLng;
              }
            }
          }
        }
      } catch (err) {
        console.log(
          "Error in " + this.displayName + ".Align overlapping markers.",
          err
        );
      }
    }
  };
  copyToClipboard = () => {
    console.log("copyToClipboard");
  };

  drawReplayMarker2 = async (replayRowArr, replayRowArrNext) => {
    let course =
      replayRowArrNext !== undefined
        ? replayRowArrNext.course
        : replayRowArr.course;
    var iconImage = this.getReplayVehicleMarkerIconUrl(
      replayRowArr.status,
      course
    );
    let latLng = new window.google.maps.LatLng(
      parseFloat(replayRowArr.latitude),
      parseFloat(replayRowArr.longitude)
    );

    var jobTripEvent = replayRowArr.remarks;
    let gpsTime = moment(replayRowArr.gpsDateTime).format("h:mm A");
    let labelContent = "";
    if (this.state.isJobTripServiceAccount) {
      if (
        jobTripEvent != undefined &&
        jobTripEvent != null &&
        jobTripEvent.length > 0
      ) {
        var eventArr = jobTripEvent.split(",");
        if (
          eventArr[0].includes("START TRIP") ||
          eventArr[0].includes("ON SCENE") ||
          eventArr[0].includes("ON BOARD") ||
          eventArr[0].includes("HOSPITAL IN") ||
          eventArr[0].includes("HOSPITAL OUT") ||
          eventArr[0].includes("CLEAR") ||
          eventArr[0].includes("ON ROAD") ||
          eventArr[0].includes("OFF ROAD")
        ) {
          labelContent =
            "<span class='fas fa-square " +
            eventArr[0].replaceAll(" ", "_") +
            "'></span> <span>" +
            eventArr[0] +
            " " +
            replayRowArr.speed +
            " km/h " +
            replayRowArr.distance +
            " km " +
            gpsTime +
            "</span>";
        }
      }
    }

    if (labelContent.length === 0) {
      labelContent =
        replayRowArr.speed +
        " km/h - " +
        replayRowArr.distance +
        " km " +
        gpsTime;
    }
    let replayMarker = null;
    if (
      this.lastAnimatedMarker == null ||
      (replayRowArrNext !== undefined &&
        replayRowArr.status !== replayRowArrNext.status)
    ) {
      if (this.lastAnimatedMarker != null) {
        //this.lastAnimatedMarker.setMap(null);        
        this.lastAnimatedMarker.map = null;
      }

      const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
      let vehicleMarkerHtml = document.createElement("div");
      vehicleMarkerHtml.innerHTML = `<div class='replayLabelCss'>${labelContent}</div>`;
      vehicleMarkerHtml.innerHTML += `<div style='text-align:center;'><img src=${iconImage} /></div>`;

      // const vehicleIcon = document.createElement("img");
      // vehicleIcon.src = iconImage;

      replayMarker = new AdvancedMarkerElement({
        position: latLng,
        map: this.map,
        title: replayRowArr.status,
        //content: vehicleIcon,
        content: vehicleMarkerHtml,
        gmpClickable: true,
      });

      // replayMarker = new MarkerWithLabel({
      //   position: latLng,
      //   map: this.map,
      //   icon: iconImage,
      //   labelContent: labelContent,
      //   labelStyle: {
      //     backgroundColor: "#ffffff",
      //     border: "1px solid #cecece",
      //     borderRadius: "8px",
      //     padding: "2px 10px 2px 10px",
      //     fontSize: "11px",
      //     fontWeight: "bold",
      //     fontFamily: "Segoe UI",
      //     color: "#095590",
      //   },
      //   labelAnchor: new window.google.maps.Point(0, 0),
      //   title: replayRowArr.status,
      // });
    } else {
      // replayMarker = this.lastAnimatedMarker;
      // replayMarker.setIcon(iconImage);
      // replayMarker.setPosition(latLng);
      // replayMarker.labelContent = labelContent;

      let vehicleMarkerHtml = document.createElement("div");
      vehicleMarkerHtml.innerHTML = `<div class='replayLabelCss'>${labelContent}</div>`;
      vehicleMarkerHtml.innerHTML += `<div style='text-align:center;'><img src=${iconImage} /></div>`;

      console.log(vehicleMarkerHtml.innerHTML);

      const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
      //replayMarker = new AdvancedMarkerElement();
      replayMarker = this.lastAnimatedMarker;

      // replayMarker = new AdvancedMarkerElement({
      //   position: latLng,
      //   map: this.map,
      //   //title: replayRowArr.status,
      //   //content: vehicleIcon,
      //   //content: vehicleMarkerHtml,
      //   //gmpClickable: true,
      // });

      replayMarker.position = latLng;
      replayMarker.content = vehicleMarkerHtml;

      //replayMarker.content = vehicleMarkerHtml;
      //replayMarker.position(latLng);
      //replayMarker.position = latLng;
      //replayMarker.labelContent = labelContent;
    }
    return replayMarker;
  };

  drawReplayMarker = async (replayRowArr, movingstatus) => {
    let replayMarker = {};
    try {
      let latLng = {
        lat: parseFloat(replayRowArr.latitude),
        lng: parseFloat(replayRowArr.longitude),
      };
      let zIndex = 200,
        iconImage = "";

      let overSpeed = false;
      let stopEvent = false;
      if (movingstatus === "start") {
        iconImage = "../assets/img/replay/ico-map-start.png?v=1.0";
        zIndex = 201;
      } else if (movingstatus === "end") {
        zIndex = 200;
        iconImage = "../assets/img/replay/ico-map-stop.png?v=1.0";
        if (
          moment(moment().format("MM/DD/YYYY HH:mm")).diff(
            moment(replayRowArr.gpsDateTime),
            "minute"
          ) < 15
        ) {
          iconImage = "../assets/img/replay/ico-map-here.png?v=1.0";
        }
      } else if (movingstatus === "position") {
        if (this.state.previewTypeId === "0") {
          if (replayRowArr.isOverSpeed && this.state.overspeedChecked) {
            iconImage = "../assets/img/replay/ico-map-here.png?v=1.0";
            overSpeed = true;
          } else {
            if (
              this.state.showEventLabel &&
              replayRowArr.stoppageTime != null &&
              replayRowArr.stoppageTime != ""
            ) {
              iconImage =
                "../assets/img/replay/ico-map-stop-position.png?v=1.0";
              stopEvent = true;
            } else {
              iconImage = this.getMarkerIconUrl(
                replayRowArr.status,
                replayRowArr.course
              );
            }
          }
          zIndex = 200;
        } else {
          if (replayRowArr.isOverSpeed && this.state.overspeedChecked) {
            iconImage = "../assets/img/replay/ico-map-here.png?v=1.0";
            overSpeed = true;
            zIndex = 200;
          } else {
            if (
              this.state.showEventLabel &&
              replayRowArr.stoppageTime != null &&
              replayRowArr.stoppageTime != ""
            ) {
              iconImage =
                "../assets/img/replay/ico-map-stop-position.png?v=1.0";
              stopEvent = true;
              zIndex = 200;
            }
          }
        }
      } else {
        iconImage = this.getReplayVehicleMarkerIconUrl(
          replayRowArr.status,
          replayRowArr.course
        );
      }

      var vehicleIcon = this.getReplayVehicleMarkerIconUrl(replayRowArr.status, replayRowArr.course);
      let vehicleMarkerHtml = document.createElement("div");
      vehicleMarkerHtml.innerHTML += `<div class='imagePosition'><img src=${iconImage} /></div>`;

      // const infoBoxDesc =
      // "<div>" +
      // "<b>Date Time: </b>" + moment(replayRowArr.gpsDateTime).format('DD-MMM h:mm') +
      // "<br/><b>Speed: </b>" + replayRowArr.speed  +  " kmph" +
      // "<br/><b>Odometer: </b> " + replayRowArr.odometer  +
      // "<br/><b>Location: </b> " + replayRowArr.address  +
      // "<br/><div onClick={this.copyToClipboard}>" + replayRowArr.latitude + "," + replayRowArr.longitude  +  "</div>" +
      // "<br/><span onClick= " + this.copyToClipboard() + "> Click Me 01 </span>" +
      // "</div>";

      // let infoBoxDesc =
      //   "<div><div><b>Date Time: </b>" + moment(replayRowArr.gpsDateTime).format("DD-MMM HH:mm:ss") +
      //   "</div><div><b>Speed: </b>" + replayRowArr.speed + " kmph </div><b>Odometer: </b><div>" +
      //   replayRowArr.odometer + " </div><b>Location: </b><div>" +
      //   replayRowArr.address + "<span>" +
      //   replayRowArr.latitude + "," +
      //   replayRowArr.longitude + "</span></div></div>";

      let infoBoxDesc =
        "<b>Date Time: </b>" +
        moment(replayRowArr.gpsDateTime).format("DD-MMM HH:mm:ss") +
        "<br/><b>Speed: </b>" +
        replayRowArr.speed +
        " kmph <br /><b>Odometer: </b> " +
        replayRowArr.odometer +
        " <br/><b>Location: </b> " +
        replayRowArr.address +
        "<br /><span>" +
        replayRowArr.latitude +
        "," +
        replayRowArr.longitude +
        "</span></div>";

      let replayMarker2 = null;
      let replayMarker3 = null;

      if (stopEvent) {

        // replayMarker = new MarkerWithLabel({
        //   position: latLng,
        //   map: this.map,
        //   icon: iconImage,
        //   infoBoxDesc: infoBoxDesc,
        //   labelContent: replayRowArr.stoppageTime,
        //   labelStyle: {
        //     backgroundColor: "#ffc473",
        //     border: "1px solid #cecece",
        //     borderRadius: "8px",
        //     padding: "2px 10px 2px 10px",
        //     fontSize: "11px",
        //     fontWeight: "bold",
        //     fontFamily: "Segoe UI",
        //     color: "#095590",
        //   },
        //   labelAnchor: new window.google.maps.Point(0, 20),
        //   zIndex: zIndex,
        //   title: replayRowArr.status,
        // });

        const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
        let vehicleMarkerHtml = document.createElement("div");
        vehicleMarkerHtml.innerHTML = `<div class='replayStopCss'><div><img src=${iconImage} />${replayRowArr.stoppageTime}</div>`;
        //vehicleMarkerHtml.innerHTML += `<div>${infoBoxDesc}</div><div>`;

        replayMarker = new AdvancedMarkerElement({
          position: latLng,
          map: this.map,
          title: replayRowArr.status,
          content: vehicleMarkerHtml,
          //gmpClickable: true,
        });
        replayMarker.infoBoxContent = infoBoxDesc;

      } else {
        if (this.state.previewTypeId === "1") {
          if (movingstatus === "start" || movingstatus === "end" || overSpeed) {

            // replayMarker = new window.google.maps.Marker({
            //   position: latLng,
            //   map: this.map,
            //   icon: iconImage,
            //   title: replayRowArr.status,
            //   infoBoxDesc: infoBoxDesc,
            //   zIndex: zIndex,
            // });

            let vehicleMarkerHtml = document.createElement("div");
            vehicleMarkerHtml.innerHTML = `<div class='replayStopCss'><div><img src=${iconImage} />${replayRowArr.stoppageTime}</div>`;
            //vehicleMarkerHtml.innerHTML += `<div>${infoBoxDesc}</div><div>`;

            const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
            replayMarker = new AdvancedMarkerElement({
              position: latLng,
              map: this.map,
              title: replayRowArr.status,
              content: vehicleMarkerHtml,
              //gmpClickable: true,
            });
            replayMarker.infoBoxContent = infoBoxDesc;
          }
        } else {
          // replayMarker = new window.google.maps.Marker({
          //   position: latLng,
          //   map: this.map,
          //   icon: iconImage,
          //   title: replayRowArr.status,
          //   infoBoxDesc: infoBoxDesc,
          //   zIndex: zIndex,
          // });

          const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");

          //console.log("iconImage: " + iconImage);
          let vehicleMarkerHtml = document.createElement("div");
          vehicleMarkerHtml.innerHTML = `<div class='replayStopCss'><div><img src=${iconImage} />${replayRowArr.stoppageTime}</div>`;
          //vehicleMarkerHtml.innerHTML += `<div>${infoBoxDesc}</div><div>`;

          replayMarker = new AdvancedMarkerElement({
            position: latLng,
            map: this.map,
            title: replayRowArr.status,
            content: vehicleMarkerHtml,
            //gmpClickable: true,
          });
          replayMarker.infoBoxContent = infoBoxDesc;
        }
      }

      /*
            if (this.state.previewTypeId === "1") {
                if (this.state.showEventLabel) {
                    if (replayRowArr.stoppageTime != null && replayRowArr.stoppageTime != "") {
                        replayMarker = new MarkerWithLabel({
                            position: latLng,
                            map: this.map,
                            icon: iconImage,
                            infoBoxDesc: infoBoxDesc,
                            labelContent: replayRowArr.stoppageTime,
                            labelStyle: {
                                backgroundColor: "#ffffff",
                                border: "1px solid #cecece",
                                borderRadius: "8px",
                                padding: "2px 10px 2px 10px",
                                fontSize: "11px",
                                fontWeight: "bold",
                                fontFamily: 'Segoe UI',
                                color: "#095590",
                            },
                            labelAnchor: new window.google.maps.Point(10, 62),
                            zIndex: zIndex,
                            title: replayRowArr.status,
                        });
                    }
                }
            }
            else {
                replayMarker = new window.google.maps.Marker({
                    position: latLng,
                    map: this.map,
                    icon: iconImage,
                    title: replayRowArr.status,
                    infoBoxDesc: infoBoxDesc,
                    zIndex: zIndex
                });

                if (this.state.showEventLabel) {
                    if (replayRowArr.stoppageTime != null && replayRowArr.stoppageTime != "") {
                        replayMarker2 = new MarkerWithLabel({
                            position: latLng,
                            map: this.map,
                            icon: iconImage,
                            infoBoxDesc: infoBoxDesc,
                            labelContent: replayRowArr.stoppageTime,
                            labelStyle: {
                                backgroundColor: "#ffc473",
                                border: "1px solid #cecece",
                                borderRadius: "8px",
                                padding: "2px 10px 2px 10px",
                                fontSize: "11px",
                                fontWeight: "bold",
                                fontFamily: 'Segoe UI',
                                color: "#095590",
                            },
                            labelAnchor: new window.google.maps.Point(0, 20),
                            zIndex: zIndex,
                            title: replayRowArr.status,
                        });
                    }
                }
            }
            */

      var jobTripEvent = replayRowArr.jobTripEvent;
      if (
        jobTripEvent != undefined &&
        jobTripEvent != null &&
        jobTripEvent.length > 0
      ) {
        var iconImage3 = "";
        var eventArr = jobTripEvent.split(",");
        if (eventArr[0].includes("START TRIP")) {
          iconImage3 = "../assets/img/replay/ico-map-Start_Event.png?v=1.0";
        } else if (eventArr[0].includes("ON SCENE")) {
          iconImage3 = "../assets/img/replay/ico-map-Scene_Event.png?v=1.0";
        } else if (eventArr[0].includes("ON BOARD")) {
          iconImage3 = "../assets/img/replay/ico-map-Board_Event.png?v=1.0";
        } else if (eventArr[0].includes("HOSPITAL IN")) {
          iconImage3 = "../assets/img/replay/ico-map-Hospital_Drop_Event.png?v=1.0";
        } else if (eventArr[0].includes("HOSPITAL OUT")) {
          iconImage3 = "../assets/img/replay/ico-map-Hospital_Out_Event.png?v=1.0";
        } else if (eventArr[0].includes("CLEAR")) {
          //iconImage3 = '../assets/img/replay/ico-map-Back_To_Base_Event.png?v=1.0';
          iconImage3 = "../assets/img/replay/ico-map-stop-position.png?v=1.0";
        } else if (eventArr[0].includes("ON ROAD")) {
          iconImage3 = "../assets/img/replay/ico-map-OnRoad_Event.png?v=1.0";
        } else if (eventArr[0].includes("OFF ROAD")) {
          iconImage3 = "../assets/img/replay/ico-map-OffRoad_Event.png?v=1.0";
        }
        var onlygpsTime = moment(replayRowArr.gpsDateTime).format("HH:mm:ss");

        var labelContent3 =
          "<span class='fas fa-square " +
          eventArr[0].replaceAll(" ", "_") +
          "'></span>  <span>" +
          jobTripEvent +
          " " +
          onlygpsTime +
          "</span>";
        //Changes: Stoppage time displays if vehicle status is stopped or idle
        if (
          replayRowArr.status === "Stopped" ||
          replayRowArr.status === "Idle"
        ) {
          labelContent3 =
            "<span class='fas fa-square " +
            eventArr[0].replaceAll(" ", "_") +
            "'></span>  <span>" +
            jobTripEvent +
            " " +
            replayRowArr.stoppageTime +
            "</span>";
        }

        // replayMarker3 = new MarkerWithLabel({
        //   position: latLng,
        //   map: this.map,
        //   icon: iconImage3,
        //   infoBoxDesc: infoBoxDesc,
        //   labelContent: labelContent3,
        //   //labelContent: replayRowArr.stoppageTime,
        //   labelStyle: {
        //     backgroundColor: "#ffffff",
        //     border: "1px solid #cecece",
        //     borderRadius: "8px",
        //     padding: "2px 10px 2px 10px",
        //     fontSize: "11px",
        //     fontWeight: "bold",
        //     fontFamily: "Segoe UI",
        //     color: "#095590",
        //   },
        //   labelAnchor: new window.google.maps.Point(10, 62),
        //   zIndex: zIndex,
        //   title: replayRowArr.status,
        // });

        const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");

        let vehicleMarkerHtml = document.createElement("div");
        vehicleMarkerHtml.innerHTML = `<div><img src=${iconImage3} /></div>`
        vehicleMarkerHtml.innerHTML += `<div class='replayStopCss'>${labelContent3}</div>`;
        //vehicleMarkerHtml.innerHTML += `<div>${infoBoxDesc}</div><div>`;

        replayMarker3 = new AdvancedMarkerElement({
          position: latLng,
          map: this.map,
          title: replayRowArr.status,
          content: vehicleMarkerHtml,
          //gmpClickable: true,
        });

      }

      if (movingstatus == "start" || movingstatus == "end") {
        //replayMarker.setAnimation(window.google.maps.Animation.BOUNCE);
        replayMarker.animation = window.google.maps.Animation.BOUNCE;
        setTimeout(function () {
          //replayMarker.setAnimation(null);
          replayMarker.animation = null;
        }, 3000);
      }

      // window.google.maps.event.addListener(replayMarker, "gmp_click", (event) => {
      //   this.showReplayInfoBox(replayMarker);
      // });

      if (replayMarker !== null) {
        if (replayMarker.addListener !== undefined) {
          replayMarker.addListener("gmp-click", ({ domEvent, latLng }) => {
            this.showReplayInfoBox(replayMarker);
          });
        }
      }

      if (movingstatus == "start" || movingstatus == "end") {
        this.startEndMarkers.push(replayMarker);
      } else {
        this.replayMarkers.push(replayMarker);
      }
      if (replayMarker2 != null) {
        window.google.maps.event.addListener(
          replayMarker2,
          "gmp_click",
          (event) => {
            this.showReplayInfoBox(replayMarker2);
          }
        );
        this.replayMarkers.push(replayMarker2);
      }
      if (replayMarker3 != null) {
        window.google.maps.event.addListener(
          replayMarker3,
          "gmp_click",
          (event) => {
            this.showReplayInfoBox(replayMarker3);
          }
        );
        this.replayMarkers.push(replayMarker3);
      }
      //replayMarker.setVisible(true);      
      //replayMarker.setPosition(latLng);
      //replayMarker.setIcon(iconImage);

      replayMarker.visible = true;
      replayMarker.position = latLng;
      replayMarker.content = vehicleMarkerHtml;

      let mapBounds = this.map.getBounds();
      // if (!mapBounds.contains(replayMarker.getPosition())) {
      //   this.map.panTo(latLng);
      // }

      if (!mapBounds.contains(replayMarker.position)) {
        this.map.panTo(latLng);
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".drawReplayMarker function",
        err
      );
    }
    return replayMarker;
  };

  drawRoutePolyline = (
    fromLat,
    fromLon,
    toLat,
    toLon,
    polylineColor,
    speed
  ) => {
    let polyLine = [];
    let speedwiseColorCodes = this.state.speedwiseColorCodes;
    let colorCodeValue = "red";
    // Remove previous polyline if it exists

    this.state.speedwiseColorCodes.map(function (colorcode, i) {
      if (speed >= colorcode.minSpeed && speed <= colorcode.maxSpeed) {
        colorCodeValue = colorcode.colorName;
      }
    });

    polyLine.push(
      new window.google.maps.LatLng(parseFloat(fromLat), parseFloat(fromLon))
    );
    polyLine.push(
      new window.google.maps.LatLng(parseFloat(toLat), parseFloat(toLon))
    );

    let polyline = new window.google.maps.Polyline({
      path: polyLine,
      strokeColor: colorCodeValue,
      strokeOpacity: 0.725,
      strokeWeight: 4,
    });

    polyline.setMap(this.map);
    this.replayRoutePolyLine.push(polyline);
  };

  rad = (x) => {
    return (x * Math.PI) / 180;
  };

  getDistance = (p1, p2) => {
    var R = 6378137; // Earth’s mean radius in meter
    var dLat = this.rad(p2.lat() - p1.lat());
    var dLong = this.rad(p2.lng() - p1.lng());
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.rad(p1.lat())) *
      Math.cos(this.rad(p2.lat())) *
      Math.sin(dLong / 2) *
      Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d; // returns the distance in meter
  };

  handleReplayAnim = async () => {
    clearTimeout(this.replayTimer);
    //console.log("frameCounter end " + this.frameCounter);
    this.frameCounter = 0;
    this.frameNumber = 0;
    let counter = this.replayCounter;
    clearInterval(this.childFrameTimer);

    let replayItem = this.state.trackingObj.replayData[counter];
    let replayNextItem = this.state.trackingObj.replayData[counter + 1];

    this.lastAnimatedMarker = await this.drawReplayMarker2(
      replayItem,
      replayNextItem
    );

    //console.log("lastAnimatedMarker: " + this.lastAnimatedMarker);

    let mapBounds = this.map.getBounds();
    // if (!mapBounds.contains(this.lastAnimatedMarker.getPosition())) {
    //   this.map.panTo(this.lastAnimatedMarker.getPosition());
    // }

    if (this.lastAnimatedMarker.position !== undefined) {
      if (!mapBounds.contains(this.lastAnimatedMarker.position)) {
        this.map.panTo(this.lastAnimatedMarker.position);
      }
    }

    //console.log("Parent Interval : " + this.state.replaySpeed);
    //#region  calculate frame

    if (replayNextItem !== undefined) {
      let sourceLatLng = new window.google.maps.LatLng(
        replayItem.latitude,
        replayItem.longitude
      );

      let destLatLng = new window.google.maps.LatLng(
        replayNextItem.latitude,
        replayNextItem.longitude
      );
      let distanceInMeter = this.getDistance(sourceLatLng, destLatLng);
      this.frameCounter = Number(
        (distanceInMeter / this.state.thresholdMeter).toFixed(0)
      );
      let latChange =
        (replayNextItem.latitude - replayItem.latitude) / this.frameCounter;
      let lngChange =
        (replayNextItem.longitude - replayItem.longitude) / this.frameCounter;
      if (this.frameCounter > 1) {
        //console.log("frameCount: " + this.frameCounter + " latChange: " + latChange + " lngChange: " + lngChange + " Child Interval : " + Number(this.state.replaySpeed / this.frameCounter).toFixed(0));
        this.childFrameTimer = setInterval(() => {
          //latChange, lngChange, destLatLng, frameNumber, pChildFrameTimer
          try {
            //let curLatLng = this.lastAnimatedMarker.getPosition();
            let curLatLng = this.lastAnimatedMarker.position;
            //console.log("frameNumber: " + this.frameNumber + ", CurrentLat :" + Number(curLatLng.lat() + latChange) + " CurrentLng :" + Number(curLatLng.lng() + latChange));
            if (this.frameCounter == this.frameNumber) {
              //this.lastAnimatedMarker.setPosition(destLatLng);
              this.lastAnimatedMarker.position = destLatLng;
              clearInterval(this.childFrameTimer);
            } else {
              // let newLatLng = new window.google.maps.LatLng(
              //   curLatLng.lat() + latChange,
              //   curLatLng.lng() + lngChange
              // );
              let newLatLng = new window.google.maps.LatLng(
                curLatLng.lat + latChange,
                curLatLng.lng + lngChange
              );
              //this.lastAnimatedMarker.setPosition(newLatLng);
              this.lastAnimatedMarker.position = newLatLng;
            }
          } catch (e) {
            console.log(e);
            clearInterval(this.childFrameTimer);
          }
          this.frameNumber++;
        }, Number((this.state.replaySpeed / this.frameCounter).toFixed(0)));
        //console.log("child frame break.");
      } else {
        this.frameCounter = 0;
        //console.log(" No frameCount: " + this.frameCounter + " latChange: " + latChange + " lngChange: " + lngChange + " Child Interval : " + Number(this.state.replaySpeed / this.frameCounter).toFixed(0));
      }
    }

    //#endregion

    this.replayCounter = counter + 1;

    if (this.replayCounter === this.state.trackingObj.replayData.length - 1) {
      this.replayCounter = 0;
    } else {
      this.replayTimer = setTimeout(
        this.handleReplayAnim,
        this.frameCounter > 1
          ? this.state.replaySpeed
          : this.state.replaySpeed * 0.5
      );
    }
  };

  playReplay = (e) => {
    e.preventDefault();
    try {
      if (this.state.trackingObj != null) {
        this.setState(
          { isPlay: true, isStopped: false, isPaused: false },
          () => {
            let currentWayPoint =
              this.state.trackingObj.replayData[this.replayCounter];
            if (currentWayPoint != null) {
              this.map.panTo(
                new window.google.maps.LatLng(
                  currentWayPoint.latitude,
                  currentWayPoint.longitude
                )
              );
              this.map.setZoom(15);
            }
            clearTimeout(this.replayTimer);
            this.clearReplayMarker();
            if (this.lastAnimatedMarker != null) {
              //this.lastAnimatedMarker.setMap(null);
              this.lastAnimatedMarker = null;
            }
            this.replayTimer = setTimeout(
              this.handleReplayAnim,
              this.state.replaySpeed
            );
          }
        );
      }
    } catch (err) {
      console.log("Error in " + this.displayName + ".playReplay function", err);
    }
  };

  pauseReplay = (e) => {
    e.preventDefault();
    this.setState({ isPlay: false, isStopped: false, isPaused: true }, () => {
      clearTimeout(this.replayTimer);
    });
  };

  stopReplay = (e) => {
    e.preventDefault();
    this.setState(
      { isPlay: false, isStopped: true, isPaused: true, previewTypeId: "1" },
      () => {
        this.replayCounter = 0;
        clearTimeout(this.replayTimer);
        this.handleSearch();
      }
    );
  };

  getMarkerIconUrl = (status, course) => {
    let _course = course - (course % 5);
    if (status === "Moving") {
      if (this.state.previewTypeId == "0") {
        return (
          "../assets/img/device-icons/Direction/Direction_green_" +
          _course +
          ".png?v=1.0"
        );
      } else {
        return (
          "../assets/img/device-icons/Car/Car_green_" + _course + ".png?v=1.0"
        );
      }
    } else if (status === "Stopped") {
      return (
        "../assets/img/device-icons/Direction/Direction_red_" +
        _course +
        ".png?v=1.0"
      );
    } else if (status === "Idle") {
      return (
        "../assets/img/device-icons/Direction/Direction_orange_" +
        _course +
        ".png?v=1.0"
      );
    } else {
      return (
        "../assets/img/device-icons/Direction/Direction_blue_" +
        _course +
        ".png?v=1.0"
      );
    }
  };

  getReplayVehicleMarkerIconUrl = (hostStatus, course) => {
    let _course = course - (course % 5);
    /*let iconeName = "Ambulance";
        let folderAndiconName = iconeName != '' ? iconeName : 'Car';
        var test = "../assets/img/device-icons/" + folderAndiconName + "/" + folderAndiconName + "_" + this.getColorByHostStatus(hostStatus) + (
            (iconeName != "TrainEngine" && iconeName != "AcTrainEngine") ? ("_" + _course) : "") + ".png?v=1.6";
        return test;*/
    let iconName = "Car";
    if (
      this.state.industryName.replaceAll(" ", "") ===
      IndustryType.EMERGENCYSERVICE
    ) {
      iconName = "Ambulance";
    }
    return (
      "../assets/img/device-icons/" +
      iconName +
      "/" +
      iconName +
      "_" +
      this.getColorByHostStatus(hostStatus) +
      "_" +
      _course +
      ".png?v=1.6"
    );
  };
  getColorByHostStatus = (hostStatus) => {
    let color = "";
    if (hostStatus === "") {
      color = "orange";
    } else if (hostStatus === "Moving") {
      color = "green";
    } else if (hostStatus === "Stopped") {
      color = "red";
    } else if (hostStatus === "Idle") {
      color = "orange";
    } else if (hostStatus === "Out Of Service") {
      color = "blue";
    }
    return color;
  };

  getReplayIconUrl = (hostStatus, course) => {
    let _course = course - (course % 5);
    if (hostStatus === 1) {
      return (
        "../assets/img/device-icons/Ambulance/Ambulance_green_" +
        _course +
        ".png?v=1.0"
      );
    } else if (hostStatus === 2) {
      return (
        "../assets/img/device-icons/Ambulance/Ambulance_red_" +
        _course +
        ".png?v=1.0"
      );
    } else if (hostStatus === 3) {
      return (
        "../assets/img/device-icons/Ambulance/Ambulance_orange_" +
        _course +
        ".png?v=1.0"
      );
    } else if (hostStatus === 4) {
      return (
        "../assets/img/device-icons/Ambulance/Ambulance_blue_" +
        _course +
        ".png?v=1.0"
      );
    } else {
      return "../assets/img/device-icons/Ambulance/Ambulance_blue.png?v=1.0";
    }
  };

  showReplayInfoBox = (markerDescription) => {
    if (this.replayInfoWindow != null) this.replayInfoWindow.close();
    this.replayInfoWindow = new window.google.maps.InfoWindow({
      content: markerDescription.infoBoxContent,
    });
    this.replayInfoWindow.open(this.map, markerDescription);
  };

  convertPositionListToArray = (data) => {
    var array = [];
    for (var m of data) {
      var obj = new Object();
      obj.lat = m.latitude;
      obj.lng = m.longitude;
      array.push(obj);
    }

    return array;
  };

  componentWillUnmount = () => {
    clearTimeout(this.replayTimer);
    this.setState({ isPlay: false, isStopped: true, isPaused: true });
    this.setState = (state, callback) => {
      return;
    };
  };

  closeInfo = (e) => {
    this.refs.vehicleInfoComponent.closeInfo(e);
  };

  showInfo = async (e) => {
    e.preventDefault();
    try {
      var request = new Object();
      request.UserId = parseInt(secureLocalStorage.getItem("session_userId"));
      request.AccountId = parseInt(
        secureLocalStorage.getItem("session_accountId")
      );
      request.LocationId = parseInt(
        secureLocalStorage.getItem("session_locationId")
      );
      request.IndustryId = parseInt(
        secureLocalStorage.getItem("session_industryTypeId")
      );
      request.VehicleId = this.state.vehicleId;
      const requestParams = getRequestParams("POST", request);
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
        "VehicleLastStatusFetch/GetVehicleLastStatus",
        requestParams
      );
      const allVehiclesdata = await response.json();
      const vehicledata =
        allVehiclesdata.payload != null
          ? allVehiclesdata.payload.dataValues
          : [];
      let data = vehicledata.filter(
        (f) => f.vehicleId === this.state.vehicleId
      )[0];
      this.refs.vehicleInfoComponent.showInfo(data);
    } catch (err) {
      console.log("Error in " + this.displayName + ".showInfo function", err);
    }
  };

  locateMarker = (e, data) => {
    e.preventDefault();
    this.map.setZoom(22);
    this.map.panTo(
      new window.google.maps.LatLng(data.latitude, data.longitude)
    );
  };

  setToday = (e) => {
    e.preventDefault();
    this.setState({
      fromDatetime: moment().startOf("day").toDate(),
      toDatetime: moment().endOf("day").toDate(),
    });
  };

  setYesterday = (e) => {
    e.preventDefault();
    this.setState({
      fromDatetime: moment().subtract(1, "day").startOf("day").toDate(),
      toDatetime: moment().subtract(1, "day").endOf("day").toDate(),
    });
  };

  exportButton = async (e) => {
    e.preventDefault();

    if (this.dataGrid != undefined && this.dataGrid.instance != undefined) {
      this.dataGrid.instance.exportToExcel();
    }
  };

  handleRefreshReplay = async (e) => {
    await this.handleSearch(e);
  };

  handleOnShowAddPoiModal = (e, data) => {
    e.preventDefault();
    let dataObj = {
      shapeType: 1,
      isCallFromVehicleReplayPage: true,
      coordinates: { lat: data.latitude, lng: data.longitude },
    };
    this.poiLatLong = {
      lat: Number(data.latitude),
      lng: Number(data.longitude),
    };
    this.refs.createGeofenceComponent.showInfo(dataObj);
    this.drawPoiCircle(100);
  };

  handleOnRadiusChange = (e) => {
    try {
      let radius = Number(e);
      if (this.poiLatLong !== null) {
        this.drawPoiCircle(radius);
      }
    } catch (error) {
      console.log(error);
    }
  };

  drawPoiCircle = (radius) => {
    try {
      this.clearPoiCircle();
      this.poiCircle = new window.google.maps.Circle({
        strokeColor: "#43c3e9",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#43c3e9",
        fillOpacity: 0.35,
        center: this.poiLatLong,
        radius: radius,
        map: this.map,
      });
      let zoomlevel = this.getZoomLevel(radius);
      this.map.setZoom(zoomlevel);
      this.map.panTo(this.poiLatLong);
      this.map.fitBounds(this.poiCircle.getBounds());
    } catch (error) {
      console.log(error);
    }
  };
  getZoomLevel = (radius) => {
    let zoomLevel = 17;
    let scale = radius / 500;
    zoomLevel = 16 - Math.log(scale) / Math.log(2);
    return zoomLevel;
  };
  clearPoiCircle = () => {
    if (this.poiCircle !== null) {
      this.poiCircle.setMap(null);
      this.poiCircle = null;
    }
  };

  render() {
    const renderGridAddressCell = (data) => {
      return (
        <div>
          <a
            href="#"
            style={{ textDecoration: "underline" }}
            onClick={(e) => {
              this.locateMarker(e, data.data);
            }}
          >
            <i className="fas fa-map-marker-alt"></i>{" "}
            {data.data.address.length > 70
              ? data.data.address.substring(0, 70) + "..."
              : data.data.address}
          </a>
        </div>
      );
    };

    const renderGpsDataCell = (data) => {
      return <div>{data.data.latitude + "," + data.data.longitude}</div>;
    };

    const renderGpsDateTimeCell = (data) => {
      return moment(data.value).format(DISPLAY_DATETIME_FORMAT);
    };

    const renderGridStatusCell = (data) => {
      let replayStatus = data.data.status;
      if (replayStatus === "Moving") {
        return (
          <div>
            <span className="badge badge-success">{replayStatus}</span>
          </div>
        );
      } else if (replayStatus === "Stopped") {
        return (
          <div>
            <span className="badge badge-danger">{replayStatus}</span>
          </div>
        );
      } else if (replayStatus === "Idle") {
        return (
          <div>
            <span className="badge badge-warning">{replayStatus}</span>
          </div>
        );
      } else if (replayStatus === "OutOfService") {
        return (
          <div>
            <span className="badge badge-primary">{replayStatus}</span>
          </div>
        );
      } else {
        return (
          <div>
            <span className="badge badge-primary">{replayStatus}</span>
          </div>
        );
      }
    };

    const renderIconImages = (status) => {
      let arry = [];
      for (var i = 0; i <= 360; i = i + 5) {
        arry.push(i);
      }
      return (
        <div>
          {" "}
          {arry.map((course) => (
            <img
              key={status + "_" + course}
              src={this.getReplayVehicleMarkerIconUrl(status, course)}
            />
          ))}
        </div>
      );
    };

    const renderLatLngGridCell = (data) => {
      return (
        <a
          href="#"
          style={{ textDecoration: "underline", cursor: "pointer" }}
          onClick={(e) => {
            e.preventDefault();
            navigator.clipboard.writeText(
              `${data.data.latitude},${data.data.longitude}`
            );
            toast.info(
              `[ ${data.data.latitude},${data.data.longitude} ] copied to clipboard!!!`,
              {
                //position: toast. POSITION.TOP _CENTER,
                position: 'top-center',
                autoClose: 800,
                style: { width: "340px" },
                hideProgressBar: false,
                newestOnTop: false,
                closeButton: false,
              }
            );
          }}
        >
          <i className="fas fa-copy"></i>&nbsp;{data.data.latitude},
          {data.data.longitude}
        </a>
      );
    };

    const renderAddPOIGridCell = (data) => {
      return (
        <a
          href="#"
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            this.handleOnShowAddPoiModal(e, data.data);
          }}
        >
          <i className="fas fa-map-marked-alt"></i>&nbsp;Add POI
        </a>
      );
    };

    return (
      <Fragment>
        <div>
          <div
            style={
              this.state.isSubmited
                ? { pointerEvents: "none", opacity: "0.4" }
                : {}
            }
          >
            <div className="replay-box">
              <div className="card m-0">
                <div className="card-body p-2">
                  <div
                    style={{
                      display: this.state.vehicleReplayModal ? "none" : "block",
                    }}
                  >
                    <div className="row" style={{ display: "none" }}>
                      <div
                        className="form-group"
                        style={{ marginLeft: "10px" }}
                      >
                        <label>
                          <b>
                            Note:&nbsp;Please select a vehicle to check replay.
                          </b>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="pull-left">
                        <div
                          className="form-group pull-left"
                          style={{ marginRight: "8px", width: "200px" }}
                        >
                          <label>
                            {VEHICLE_LABEL}{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <SelectBox
                            dataSource={this.state.vehicleNoList}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder={SELECT_VEHICLE_LABEL}
                            name="vehicleId"
                            defaultValue={0}
                            value={this.state.vehicleId}
                            displayExpr="vehicleNo"
                            valueExpr="vehicleId"
                            grouped={false}
                            onSelectionChanged={this.handleVehicleInputChange}
                            showClearButton={true}
                            disabled={this.state.vehicleReplayModal}
                            searchEnabled={true}
                            ref={(select) =>
                              (this.vehicleNumberSelector = select)
                            }
                          />
                          {this.state.errors["vehicleId"].length > 0 && (
                            <span className="error invalid-feedback">
                              {this.state.errors["vehicleId"]}
                            </span>
                          )}
                        </div>
                        <div
                          className="form-group pull-left "
                          style={{ marginRight: "8px", width: "320px" }}
                        >
                          <div>
                            <label>
                              Start Datetime
                              <span className="text-danger">*</span>
                            </label>
                            &nbsp;
                            <span>
                              <a
                                href="#"
                                onClick={(e) => {
                                  this.setToday(e);
                                }}
                              >
                                <b>Today</b>
                              </a>
                            </span>
                            &nbsp;|&nbsp;
                            <span>
                              <a
                                href="#"
                                onClick={(e) => {
                                  this.setYesterday(e);
                                }}
                              >
                                <b>Yesterday</b>
                              </a>
                            </span>
                          </div>
                          <div>
                            <div
                              className="pull-left"
                              style={{ width: "50%", paddingRight: "5px" }}
                            >
                              <DateBox
                                type="datetime"
                                className="replay-date-time"
                                name="fromDatetime"
                                placeholder={DATEPICKER_FORMAT}
                                displayFormat={DATEPICKER_FORMAT}
                                defaultValue={this.state.fromDatetime}
                                value={this.state.fromDatetime}
                                onValueChanged={this.handleFromDatetimeChange}
                                disabled={this.state.vehicleReplayModal}
                                useMaskBehavior={true}
                                style={{ display: "inline-block" }}
                              />
                              {this.state.errors["fromDatetime"].length > 0 && (
                                <span className="error invalid-feedback">
                                  {this.state.errors["fromDatetime"]}
                                </span>
                              )}
                            </div>
                            <div className="pull-left" style={{ width: "49%" }}>
                              <DateBox
                                type="datetime"
                                className="replay-date-time"
                                name="toDatetime"
                                placeholder={DATEPICKER_FORMAT}
                                displayFormat={DATEPICKER_FORMAT}
                                defaultValue={this.state.toDatetime}
                                value={this.state.toDatetime}
                                onValueChanged={this.handleToDatetimeChange}
                                disabled={this.state.vehicleReplayModal}
                                useMaskBehavior={true}
                                style={{ display: "inline-block" }}
                              />
                              {this.state.errors["toDatetime"].length > 0 && (
                                <span className="error invalid-feedback">
                                  {this.state.errors["toDatetime"]}
                                </span>
                              )}
                            </div>
                            <div className="clearboth"></div>
                          </div>
                        </div>
                        <div
                          className={
                            this.state.vehicleReplayModal === true
                              ? "pull-left displayNone"
                              : "pull-left displayBlock"
                          }
                          style={{ marginRight: "8px", width: "100px" }}
                        >
                          <div className="form-group">
                            <label>Preview</label>
                            <select
                              className="replay-select-box"
                              name="previewTypeId"
                              placeholder="Select preview type"
                              title="Preview Type"
                              value={this.state.previewTypeId}
                              onChange={this.handleInputChange}
                            >
                              <option value={0}>Pinned</option>
                              <option value={1}>Animated</option>
                            </select>
                          </div>
                        </div>
                        <div className="clearboth"></div>
                      </div>
                      {/* */}
                      <div className="pull-left">
                        <div
                          className={
                            this.state.vehicleReplayModal === true
                              ? "pull-left displayNone"
                              : "pull-left displayBlock mt-4"
                          }
                          style={{ marginRight: "8px", width: "100px" }}
                        >
                          <div style={{ float: "left" }}>
                            <input
                              type="checkbox"
                              value={this.state.overspeedChecked}
                              checked={this.state.overspeedChecked}
                              onChange={this.checkChanged}
                            />
                          </div>
                          <div style={{ float: "left" }}>
                            &nbsp;&nbsp;Overspeed
                          </div>
                          <div className="clearboth"></div>
                        </div>
                        <div
                          className={
                            this.state.vehicleReplayModal === true
                              ? "pull-left displayNone"
                              : "pull-left displayBlock mt-4"
                          }
                          style={{ marginRight: "8px", width: "70px" }}
                        >
                          <div style={{ float: "left" }}>
                            <input
                              type="checkbox"
                              value={this.state.showEventLabel}
                              checked={this.state.showEventLabel}
                              onChange={this.checkEventChanged}
                            />
                          </div>
                          <div style={{ float: "left" }}>
                            &nbsp;&nbsp;Events
                          </div>
                          <div className="clearboth"></div>
                        </div>

                        <div
                          className="pull-left mt-1"
                          style={{ marginRight: "8px", width: "70px" }}
                        >
                          <div className="form-group">
                            <label>Show POI</label>
                            <br />
                            <label className="custom-switch mt-1">
                              <input
                                type="checkbox"
                                checked={this.state.showPoiOnMap}
                                onChange={this.handleTogglePoisEvent}
                                name="showPoiLabel"
                                className="custom-switch-input"
                              />
                              <span className="custom-switch-indicator"></span>
                            </label>
                          </div>
                        </div>
                        <div
                          className="pull-left mt-1"
                          style={{ marginRight: "8px", width: "120px" }}
                        >
                          <div className="form-group">
                            <label>Show Summary</label>&nbsp;
                            <label className="custom-switch mt-1">
                              <input
                                type="checkbox"
                                checked={this.state.showSummary}
                                onChange={this.handleShowHideSummaryEvent}
                                name="showSummaryLabel"
                                className="custom-switch-input"
                              />
                              <span className="custom-switch-indicator"></span>
                            </label>
                          </div>
                        </div>
                        <div
                          className="pull-left"
                          style={{
                            display:
                              this.state.displayPlayReplay === 1
                                ? "block"
                                : "none",
                          }}
                        >
                          <div className="form-group mt-15">
                            <div
                              style={{ display: "flex", marginBottom: "4px" }}
                            >
                              <select
                                className="replay-select-box"
                                name="replaySpeed"
                                placeholder="Select speed"
                                title="Speed Type"
                                value={this.state.replaySpeed}
                                onChange={this.handleSpeedChange}
                              >
                                <option value={200}>Normal</option>
                                <option value={150}>2x</option>
                                <option value={100}>4x</option>
                                <option value={50}>8x</option>
                              </select>
                              &nbsp;&nbsp;
                              <button
                                className="btn btn-icon btn-sm btn-light replay-animation-button"
                                disabled={this.state.isPlay}
                                onClick={this.playReplay}
                              >
                                <i className="fas fa-play"></i>
                              </button>
                              <button
                                className="btn btn-icon btn-sm btn-light replay-animation-button"
                                disabled={this.state.isPaused}
                                onClick={this.pauseReplay}
                              >
                                <i className="fas fa-pause"></i>
                              </button>
                              <button
                                className="btn btn-icon btn-sm btn-light replay-animation-button"
                                disabled={this.state.isStopped}
                                onClick={this.stopReplay}
                              >
                                <i className="fas fa-stop"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            this.state.vehicleReplayModal === true
                              ? "pull-left displayNone"
                              : "pull-left displayBlock mt-3"
                          }
                          style={{ marginRight: "8px", width: "100px" }}
                        >
                          <div className="form-group">
                            <button
                              type="submit"
                              className="btn btn-success"
                              style={{ fontSize: 12 + "px" }}
                              onClick={this.handleSearch}
                            >
                              {this.state.isSubmited && (
                                <span title="In-process">
                                  <i className="fas fa-spinner fa-spin"></i>{" "}
                                  In-process
                                </span>
                              )}
                              {!this.state.isSubmited && (
                                <span title="Replay">
                                  <i className="fas fa-redo"></i> Replay
                                </span>
                              )}
                            </button>
                          </div>
                        </div>
                        <div className="clearboth"></div>
                      </div>
                      {/* */}
                      <div className="clearboth"></div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: this.state.vehicleReplayModal ? "block" : "none",
                    }}
                  >
                    <div className="text-primary p-0 m-0">
                      <span style={{ fontWeight: "bold" }}>Trip Number</span> :{" "}
                      {this.state.tripJobNumber} &nbsp;&nbsp;
                      <span style={{ fontWeight: "bold" }}>
                        Start Time
                      </span> : {this.state.tripStartDatetime}&nbsp;&nbsp;
                      <span style={{ fontWeight: "bold" }}>
                        Start Location
                      </span>{" "}
                      : {this.state.tripStartLocation}&nbsp;&nbsp;
                      <span style={{ fontWeight: "bold" }}>
                        End Time
                      </span> : {this.state.tripEndDatetime}&nbsp;&nbsp;
                      <span style={{ fontWeight: "bold" }}>
                        End Location
                      </span> : {this.state.tripEndLocation}&nbsp;&nbsp;
                      <span style={{ fontWeight: "bold" }}>
                        Route Name
                      </span> : {this.state.tripRouteName} &nbsp;&nbsp;
                      <span style={{ fontWeight: "bold" }}>
                        Trip Status{" "}
                      </span> : {this.state.tripTripStatusName}
                    </div>
                    <div className="pull-left" style={{ paddingTop: "5px" }}>
                      <div className="form-group">
                        <label>Preview Type:</label>
                      </div>
                    </div>
                    <div
                      className="pull-left"
                      style={{ marginRight: "8px", width: "120px" }}
                    >
                      <div className="form-group">
                        <select
                          className="replay-select-box"
                          name="previewTypeId"
                          placeholder="Select preview type"
                          title="Preview Type"
                          value={this.state.previewTypeId}
                          onChange={this.handleInputChange}
                        >
                          <option value={0}>Pinned</option>
                          <option value={1}>Animated</option>
                        </select>
                      </div>
                    </div>
                    <div
                      className="pull-left"
                      style={{
                        paddingTop: "5px",
                        display:
                          this.state.previewTypeId == 1 ? "block" : "none",
                      }}
                    >
                      <div className="form-group">
                        <label>Speed Type:</label>
                      </div>
                    </div>
                    <div
                      className="pull-left"
                      style={{
                        display:
                          this.state.previewTypeId == 1 ? "block" : "none",
                      }}
                    >
                      <div className="form-group">
                        <div style={{ display: "flex", marginBottom: "4px" }}>
                          <select
                            className="replay-select-box"
                            name="replaySpeed"
                            placeholder="Select speed"
                            title="Speed Type"
                            value={this.state.replaySpeed}
                            onChange={this.handleSpeedChange}
                          >
                            <option value={200}>Normal</option>
                            <option value={150}>2x</option>
                            <option value={100}>4x</option>
                            <option value={50}>8x</option>
                          </select>
                          &nbsp;&nbsp;
                          <button
                            className="btn btn-icon btn-sm btn-light replay-animation-button"
                            disabled={this.state.isPlay}
                            onClick={this.playReplay}
                          >
                            <i className="fas fa-play"></i>
                          </button>
                          <button
                            className="btn btn-icon btn-sm btn-light replay-animation-button"
                            disabled={this.state.isPaused}
                            onClick={this.pauseReplay}
                          >
                            <i className="fas fa-pause"></i>
                          </button>
                          <button
                            className="btn btn-icon btn-sm btn-light replay-animation-button"
                            disabled={this.state.isStopped}
                            onClick={this.stopReplay}
                          >
                            <i className="fas fa-stop"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="pull-left">
                      <div className="form-group">
                        <button
                          type="submit"
                          className="btn btn-icon btn-sm btn-success"
                          style={{
                            display: this.state.showRefreshBtn ? "" : "none",
                          }}
                          onClick={this.handleRefreshReplay}
                        >
                          <i className="fas fa-sync"></i> Refresh
                        </button>
                        &nbsp;
                        <label>Show Summary</label>&nbsp;
                        <label className="custom-switch">
                          <input
                            type="checkbox"
                            checked={this.state.showSummary}
                            onChange={this.handleShowHideSummaryEvent}
                            name="showSummaryLabel"
                            className="custom-switch-input"
                          />
                          <span className="custom-switch-indicator"></span>
                        </label>
                      </div>
                    </div>
                    <div className="clearboth"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              height: "81.5vh",
              position: "relative",
              float: "right",
              width: "100%",
            }}
          >
            <div className="legendsPanel03">
              {this.state.isJobTripServiceAccount && (
                <span className="srviceTypeLegends hide768">
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square START_TRIP"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> START TRIP</span>
                  </div>
                  <div className="pull-right"></div>
                  <br />
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square ON_ROAD"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> ON ROAD</span>
                  </div>
                  <br />
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square ON_SCENE"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> ON SCENE</span>
                  </div>
                  <br />
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square ON_BOARD"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> ON BOARD</span>
                  </div>
                  <br />
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square HOSPITAL_IN"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> HOSPITAL IN</span>
                  </div>
                  <br />
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square HOSPITAL_OUT"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> HOSPITAL OUT</span>
                  </div>
                  <br />
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square CLEAR"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> CLEAR</span>
                  </div>
                  <br />
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square OFF_ROAD"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> OFF ROAD</span>
                  </div>
                  <br />

                  <div
                    className="pull-left"
                    style={{
                      marginRight: "10px",
                      marginTop: "15px",
                      marginBottom: "8px",
                    }}
                  >
                    <span style={{ fontSize: "9px", fontWeight: "bold" }}>
                      Speed Code :{" "}
                    </span>
                  </div>
                  <br />
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square lessThen39"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> less than 39</span>
                  </div>
                  <br />
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square between40To59"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> 40 to 59</span>
                  </div>
                  <br />
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square between60To89"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> 60 to 89</span>
                  </div>
                  <br />
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square between90To119"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> 90 to 119</span>
                  </div>
                  <br />
                  <div className="pull-left" style={{ marginRight: "10px" }}>
                    <span
                      className="fas fa-square between120To300"
                      style={{ fontSize: "10px" }}
                    ></span>
                    &nbsp;<span style={{ fontSize: "9px" }}> 120 to 300</span>
                  </div>
                  <br />
                  <div className="clearfix"></div>
                </span>
              )}
            </div>
            {/* google map */}
            <div
              ref={this.mapRef}
              id="map"
              style={{ height: `83vh`, width: `100%` }}
            ></div>
          </div>
          <div>
            {/* <RegularMap
                            googleMapURL={window.google.toString()}
                            loadingElement={loadingElement}
                            containerElement={containerElement}
                            mapElement={mapElement}
                            center={this.state.center}
                            zoom={this.state.zoom}
                            trackingObj={this.state.trackingObj}
                            previewTypeId={this.state.previewTypeId}
                            progress={this.state.progress}
                            closeInfo={this.closeInfo}
                        /> */}
          </div>
          {this.state.trackingObj !== null && this.state.showSummary && (
            <div className="row">
              {/* <div className={this.state.vehicleReplayModal === true ? "col-lg-12 replay-bottom-grid displayNone" : "col-lg-12 replay-bottom-grid displayBlock"} name="footerGrid"> */}
              <div
                className="col-lg-12 replay-bottom-grid displayBlock"
                name="footerGrid"
              >
                <div className="card">
                  <div className="card-body">
                    <div className="replay-title">
                      <div className="pull-left">
                        <a
                          href="#collapseExample"
                          className="btn btn-icon btn-sm btn-warning"
                          data-toggle="collapse"
                          role="button"
                          aria-expanded="true"
                          aria-controls="collapseExample"
                        >
                          <i className="fas fa-minus"></i>
                        </a>
                        &nbsp;&nbsp;{" "}
                        <span style={{ fontSize: "12px" }}>
                          Summary - {VEHICLE_LABEL} :
                          <a
                            href="#"
                            className="btn-social-icon"
                            title="Vehicle No"
                            onClick={(e) => {
                              this.showInfo(e);
                            }}
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            {this.state.vehicleNo}
                          </a>
                        </span>
                      </div>
                      <div className="pull-right">
                        <i className="fas fa-file-export"></i>
                        <a
                          href="#"
                          className="btn-social-icon"
                          title="Export To Excel"
                          onClick={(e) => {
                            this.exportButton(e);
                          }}
                          style={{
                            fontSize: "12px",
                            marginLeft: "-10px",
                            fontWeight: "bold",
                          }}
                        >
                          Export To Excel
                        </a>
                      </div>
                      <div className="clearfix"></div>
                    </div>
                    <div className="col-lg-12 data3">
                      <div className="pull-left pr-15">
                        <span>
                          Total Moving Time:{" "}
                          <span
                            className="text-success font-weight-bold"
                            id="totalMovingTime"
                          >
                            {this.state.trackingObj.totalMovingTime}
                          </span>
                        </span>
                      </div>
                      <div className="pull-left pr-15">
                        <span>
                          Total Idle Time:{" "}
                          <span
                            className="text-warning font-weight-bold"
                            id="totalIdleTime"
                          >
                            {this.state.trackingObj.totalIdleTime}
                          </span>
                        </span>
                      </div>
                      <div className="pull-left pr-15">
                        <span>
                          Total Stopped Time:{" "}
                          <span
                            className="text-danger font-weight-bold"
                            id="totalStoppedTime"
                          >
                            {this.state.trackingObj.totalStoppedTime}
                          </span>
                        </span>
                      </div>
                      <div className="pull-left pr-15">
                        <span>
                          Total Time:{" "}
                          <span
                            className="text-primary font-weight-bold"
                            id="totalTime"
                          >
                            {this.state.trackingObj.totalTime}
                          </span>
                        </span>
                      </div>
                      <div className="pull-left pr-15">
                        <span>
                          Avg Speed:{" "}
                          <span
                            className="text-warning font-weight-bold"
                            id="avgSpeed"
                          >
                            {this.state.trackingObj.averageSpeed} kmph
                          </span>
                        </span>
                      </div>
                      <div className="pull-left pr-15">
                        <span>
                          Max Speed:{" "}
                          <span
                            className="text-warning font-weight-bold"
                            id="maxSpeed"
                          >
                            {this.state.trackingObj.maxSpeed} kmph
                          </span>
                        </span>
                      </div>
                      <div className="pull-left pr-15">
                        <span>
                          Total Distance:{" "}
                          <span
                            className="text-info font-weight-bold"
                            id="vehicle_total_km"
                          >
                            {Math.round(
                              this.state.trackingObj.totalDistance,
                              2
                            )}{" "}
                            KM
                          </span>
                        </span>
                      </div>
                      <div className="clearfix"></div>
                      <Export
                        fileName={this.state.exportFileName}
                        enabled={true}
                        allowExportSelectedData={false}
                      />
                    </div>
                    <div className="collapse show" id="collapseExample">
                      <div
                        className="table-responsive"
                        style={{ maxHeight: "150px" }}
                      >
                        <div className="section-body">
                          <DataGrid
                            id="vehicleReplay"
                            dataSource={this.state.trackingObj.replayData}
                            selection={{ mode: "single" }}
                            columnsAutoWidth={false}
                            showColumnLines={false}
                            showRowLines={true}
                            showBorders={true}
                            //components={{ Toolbar: MyExportButton }}
                            rowAlternationEnabled={false}
                            ref={(ref) => (this.dataGrid = ref)}
                            allowColumnResizing={true}
                            columnResizingMode="widget"
                          >
                            {/* <Column dataField="gpsDateTime" width={150} allowFiltering={false} allowSorting={true} cellRender={renderGpsDateTimeCell} caption="DateTime"  dataType="datetime" />   */}
                            <Column
                              dataField="gpsDateTime"
                              width={150}
                              allowFiltering={false}
                              allowSorting={true}
                              caption="Date Time"
                              dataType="datetime"
                              format="yyyy-MM-dd HH:mm:ss"
                            />
                            <Column
                              dataField="status"
                              width={60}
                              allowFiltering={false}
                              allowSorting={true}
                              caption="Status"
                              cellRender={renderGridStatusCell}
                            />
                            <Column
                              dataField="speed"
                              width={80}
                              allowFiltering={false}
                              allowSorting={true}
                              caption="Speed"
                            />
                            <Column
                              dataField="distance"
                              width={80}
                              allowFiltering={false}
                              allowSorting={true}
                              caption="KM"
                            />
                            <Column
                              dataField="odometer"
                              width={120}
                              allowFiltering={false}
                              allowSorting={true}
                              caption="Odometer"
                            />
                            <Column
                              dataField="address"
                              width={400}
                              allowFiltering={false}
                              allowSorting={true}
                              caption="Location"
                              cellRender={renderGridAddressCell}
                            />
                            {/*<Column dataField="" width={180} allowFiltering={false} allowSorting={false} caption="GeoLocation" cellRender={renderGpsDataCell} />*/}
                            <Column
                              dataField="remarks"
                              width={150}
                              allowFiltering={false}
                              allowSorting={true}
                              caption="Stopped/Idle Time"
                            />
                            <Column
                              allowFiltering={false}
                              allowSorting={true}
                              width={"max"}
                              cellRender={renderLatLngGridCell}
                              headerCellRender={() => {
                                return (
                                  <>
                                    <i className="fas fa-copy"></i>&nbsp;Lat/Lng
                                  </>
                                );
                              }}
                            />
                            <Column
                              caption="Add POI's"
                              allowFiltering={false}
                              allowSorting={true}
                              width={"max"}
                              visible={this.state.allowToAddPoi}
                              cellRender={renderAddPOIGridCell}
                            />
                            <Export fileName={this.state.exportFileName} />

                            <Paging enabled={false} />
                          </DataGrid>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <VehicleInfoComponent
            ref="vehicleInfoComponent"
            closeOtherWindows={this.fnCloseOtherWindows}
          />
        </div>
        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          //position={position}
          visible={this.state.loadPanelVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />
        <div style={{ display: "none" }}>{renderIconImages("Moving")}</div>
        <div style={{ display: "none" }}>{renderIconImages("Stopped")}</div>
        <div style={{ display: "none" }}>{renderIconImages("Idle")}</div>
        <div style={{ display: "none" }}>
          {renderIconImages("Out Of Service")}
        </div>
        <CreateGeofenceComponent
          ref="createGeofenceComponent"
          cancelInfo={() => {
            this.refs.createGeofenceComponent.cancelPlotBtnClick();
            this.clearPoiCircle();
            this.poiLatLong = null;
          }}
          closeModal={() => {
            this.clearPoiCircle();
            this.poiLatLong = null;
          }}
          reloadData={() => { }}
          onRadiusChange={(e) => {
            this.handleOnRadiusChange(e);
          }}
        />
      </Fragment>
    );
  }
}
